import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../../_auth/auth.service';

@Component({
    selector: 'lokos-role-not-found',
    templateUrl: './role-not-found.component.html',
    styleUrl: './role-not-found.component.scss',
    standalone: false,
})
export class RoleNotFoundComponent {
    constructor(
        private authService: AuthService,
        private router: Router
    ) {}

    logout() {
        this.authService.logout();
    }

    navigate() {
        this.router.navigate(['/main/role-request']);
    }
}
